/* 
* <license header>
*/

import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { postReset, hasImsForReset } from './votingApi'

const STORAGE_KEY = 'admin-controls-visible'

export default function AdminControls ({ ims }) {
  const [visible, setVisible] = useState(false)
  const [resetting, setResetting] = useState(false)
  const canReset = hasImsForReset(ims)

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY)
    setVisible(stored === 'true')
  }, [])

  const toggleVisible = () => {
    const next = !visible
    setVisible(next)
    localStorage.setItem(STORAGE_KEY, String(next))
  }

  const handleReset = async () => {
    if (!canReset) return
    setResetting(true)
    try {
      await postReset(ims)
      window.location.reload()
    } catch (e) {
      console.error(e)
    } finally {
      setResetting(false)
    }
  }

  return (
    <div className="wv-admin-row">
      <button type="button" onClick={toggleVisible} className="wv-admin-toggle">
        {visible ? 'Hide admin' : 'Show admin'}
      </button>
      {visible && (
        <button
          type="button"
          onClick={handleReset}
          disabled={resetting || !canReset}
          className="wv-btn-reset"
          title={!canReset ? 'Sign in via Experience Cloud to reset' : undefined}
        >
          {resetting ? 'Resetting…' : 'Reset to default'}
        </button>
      )}
    </div>
  )
}

AdminControls.propTypes = {
  ims: PropTypes.object
}
